import type {
  Body_support_post_ticket_api_helpdesk_tickets_post,
  IResponse,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export type IHelpdeskRequestData = Omit<
  Body_support_post_ticket_api_helpdesk_tickets_post,
  "log"
>;

export const helpdeskApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    createTicket: build.mutation<IResponse, IHelpdeskRequestData>({
      query: data => {
        const formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
          formData.append(key, value);
        }
        // скорей всего ожидается лог из приложения, в браузере нам отправлять нечего, поэтому всегда пустой Blob
        // если не отправлять это поле совсем или что-то кроме бинарника, то запрос падает с ошибкой 422
        formData.append("log", new Blob([""]));
        return {
          url: "/foundation/api/helpdesk/tickets",
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data;",
          },
          body: formData,
          formData: true,
        };
      },
    }),
  }),
});
